var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.myMode)?_c('elem',{attrs:{"mode":_vm.myMode,"root":true},on:{"onEvent":_vm.onEvent}},[_vm._t("default")],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }